'use client';
import { jsx } from 'react/jsx-runtime';
import { useAvatarContext } from './avatar-context.mjs';
import { chakra } from '../system/factory.mjs';

function AvatarImage(props) {
  const {
    borderRadius,
    src,
    name,
    srcSet,
    loading,
    referrerPolicy,
    crossOrigin,
    showFallback
  } = useAvatarContext();
  if (showFallback)
    return null;
  return /* @__PURE__ */ jsx(
    chakra.img,
    {
      src,
      srcSet,
      alt: name,
      referrerPolicy,
      crossOrigin,
      className: "chakra-avatar__img",
      loading,
      __css: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius
      },
      ...props
    }
  );
}
AvatarImage.displayName = "AvatarImage";

export { AvatarImage };
